import { put, call, fork, all, takeLatest, select } from "redux-saga/effects";
import * as doctorTypes from "~/store/doctor/doctorTypes";
import { getAllDoctorByFilter } from "~/store/doctor/doctorApi";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { apiRequestSpecialistByHospital } from "~/store/dateAndSpecialist/dateAndSpecialistAPI";

/* choose hospital list */
function* requestDoctorListByFilter() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const selectedHospital = yield select(state =>
      state.hospital ? state.hospital.selectedHospital : 0
    );
    const { info } = yield select(state => state.user);
    const doctorParams = yield select(state => state.doctor);

    const response = yield call(
      getAllDoctorByFilter,
      baseUrl,
      info,
      doctorParams.pageSize,
      doctorParams.pageIndex,
      doctorParams.info,
      selectedHospital
    );
    const { data } = response;
    if (typeof data.error_code !== typeof undefined) {
      throw new Error("Lỗi server!");
    }
    const { total: totalRows, rows } = data;
    const {
      device: { type }
    } = yield select(state => state.global);

    if (type === "desktop") {
      yield put({
        type: doctorTypes.GET_ALL_DOCTOR_LIST_DESKTOP_SUCCESS,
        totalRows,
        rows
      });
    } else {
      yield put({
        type: doctorTypes.GET_ALL_DOCTOR_LIST_SUCCESS,
        totalRows,
        rows
      });
    }
  } catch (errors) {
    yield put({
      type: doctorTypes.GET_ALL_DOCTOR_LIST_FAILURE,
      errors
    });
  }
}

function* requestAllDoctorSpecialist() {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const { info } = yield select(state => state.user);
    const response = yield call(apiRequestSpecialistByHospital, baseUrl, info);
    const { data } = response;
    if (typeof data.error_code !== typeof undefined) {
      throw new Error("Lỗi server!");
    }
    yield put({
      type: doctorTypes.GET_ALL_DOCTOR_SPECIALIST_SUCCESS,
      subject: data.data
    });
  } catch (errors) {
    yield put({
      type: doctorTypes.GET_ALL_DOCTOR_SPECIALIST_FAILURE,
      errors
    });
  }
}

function* watchRequestDoctorListByFilter() {
  yield takeLatest(
    doctorTypes.GET_ALL_DOCTOR_LIST_REQUEST,
    requestDoctorListByFilter
  );
  yield takeLatest(
    doctorTypes.GET_ALL_DOCTOR_SPECIALIST_REQUEST,
    requestAllDoctorSpecialist
  );
  yield takeLatest(
    doctorTypes.DOCTOR_FORM_SAVE_FIELD,
    requestDoctorListByFilter
  );
}

export default function* root() {
  yield all([fork(watchRequestDoctorListByFilter)]);
}
